// assets
import { IconFileExport, IconFileInvoice, IconReceiptTax, IconWallet } from '@tabler/icons-react';

// types
import { NavItemType } from 'types';

// ==============================|| MENU ITEMS - BILLING (P3-2) ||============================== //

const billing: NavItemType = {
  id: 'billing',
  title: 'billing', // react-intl key - i18n-ready [STD-DRIFT]
  icon: IconReceiptTax,
  type: 'group',
  requiredModule: 'billing',
  children: [
    {
      id: 'billing-invoices',
      title: 'billing-invoices',
      icon: IconFileInvoice,
      type: 'item',
      url: '/billing/invoices',
      module: 'billing.invoices'
    },
    {
      id: 'billing-payouts',
      title: 'billing-payouts',
      icon: IconWallet,
      type: 'item',
      url: '/billing/payouts',
      module: 'billing.payouts'
    },
    {
      id: 'billing-export',
      title: 'billing-export',
      icon: IconFileExport,
      type: 'item',
      url: '/billing/export',
      module: 'billing.invoices'
    }
  ]
};

export default billing;
